// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"Video_videoWrapper__kvSjC","video":"Video_video__nrbC8","playButton":"Video_playButton__k7Xy4","thumbnail":"Video_thumbnail__8v0u2"};